import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldsetComponent, InputErrorComponent, InvalidTypeDirective } from '@woolworthsnz/form';
import { NgFor } from '@angular/common';

interface Option {
	text: string;
	value: string;
	selected: boolean;
}

@Component({
	selector: 'dc-form-dropdown',
	templateUrl: './form-dropdown.component.html',
	styleUrls: ['./form-dropdown.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [FieldsetComponent, FormsModule, ReactiveFormsModule, NgFor, InputErrorComponent, InvalidTypeDirective]
})
export class FormDropdownComponent {
	@Input() label: string;
	@Input() options: Option[];
	@Input() formControlName: string;
	@Input() group: FormGroup;
}
